export function pathForBreadcrumb(item) {
  if (item.type === "Brand") {
    return `/knowledge/arrange`;
  }

  return `/knowledge/arrange/${
    item.type === "Section" ? "sections" : "categories"
  }/${item.id}`;
}



// WEBPACK FOOTER //
// ./src/utils/pathForBreadcrumb.js